import React, { Component } from "react";
import { utils } from "../common/utils";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withTranslation } from 'react-i18next';
import SocialAccounts from "../components/SocialAccounts";
import { SiteLinkTypes } from "../common/enums";

class AboutMe extends Component {


    render() {

        const { t, user, settings, siteLinks, locale } = this.props;

        const imageUrl = user.representative.imageUrl ? user.representative.imageUrl : settings.defaultImageUrl;
        let aboutMeButton1 = [], aboutMeButton2 = [], aboutMeButton3 = [], aboutMeButton4 = [];

        if (siteLinks.aboutMeButtons) {
            aboutMeButton1 = siteLinks.aboutMeButtons.filter(l => l.linkType == SiteLinkTypes.AboutMeButton1 && ((utils.isNullOrEmpty(l.locale) || l.locale === locale)))[0],
                aboutMeButton2 = siteLinks.aboutMeButtons.filter(l => l.linkType == SiteLinkTypes.AboutMeButton2 && ((utils.isNullOrEmpty(l.locale) || l.locale === locale)))[0],
                aboutMeButton3 = siteLinks.aboutMeButtons.filter(l => l.linkType == SiteLinkTypes.AboutMeButton3 && ((utils.isNullOrEmpty(l.locale) || l.locale === locale)))[0],
                aboutMeButton4 = siteLinks.aboutMeButtons.filter(l => l.linkType == SiteLinkTypes.AboutMeButton4 && ((utils.isNullOrEmpty(l.locale) || l.locale === locale)))[0];
        }
        const aboutMeButton1Url = aboutMeButton1 ? utils.getLinkUrl(aboutMeButton1, settings) : null,
            aboutMeButton1Title = aboutMeButton1 ? aboutMeButton1.name : t("How to earn money selling ENJO"),
            aboutMeButton1Target = aboutMeButton1 ? aboutMeButton1.target : "_blank",

            aboutMeButton2Url = aboutMeButton2 ? utils.getLinkUrl(aboutMeButton2, settings) : null,
            aboutMeButton2Title = aboutMeButton2 ? aboutMeButton2.name : t("Book A Demo"),
            aboutMeButton2Target = aboutMeButton2 ? aboutMeButton2.target : "_blank",

            aboutMeButton3Url = aboutMeButton3 ? utils.getLinkUrl(aboutMeButton3, settings) : null,
            aboutMeButton3Title = aboutMeButton3 ? aboutMeButton3.name : t("Become an ENJOpreneur"),
            aboutMeButton3Target = aboutMeButton3 ? aboutMeButton3.target : "_blank",

            aboutMeButton4Url = aboutMeButton4 ? utils.getLinkUrl(aboutMeButton4, settings) : null,
            aboutMeButton4Title = aboutMeButton4 ? aboutMeButton4.name : t("Ask Me"),
            aboutMeButton4Target = aboutMeButton4 ? aboutMeButton4.target : "_blank";

        const welcomeMessage = utils.isNullOrEmpty(user.representative.welcomeMessage) ? t("DefaultWelcomeMessage") : user.representative.welcomeMessage,
            aboutMeMessage = utils.isNullOrEmpty(user.representative.aboutMe) ? t("DefaultAboutMeMessage") : user.representative.aboutMe,
            youtubeMessageUrl = utils.isNullOrEmpty(user.representative.youtubeMessageUrl) ? t("DefaultYoutubeMessageUrl") : user.representative.youtubeMessageUrl;

        return (
            <div className="row">
                <div className="col-sm-4 mb-4">
                    <div className="card text-center align-items-center">
                        {imageUrl && <img className="card-img-top epr-profile-img" src={imageUrl} alt="" />}
                        <div className="card-body">
                            <h5 className="card-title mb-2">{user.representative.name}</h5>

                        </div>
                    </div>
                    <section className="widget mt-2">
                        {user.representative.phone && <p>{t("Phone")}: {user.representative.phone}</p>}
                        {user.representative.mobile && <p>{t("Mobile")}: {user.representative.mobile}</p>}
                        <p><a className="navi-link" href={`mailto:${user.representative.email}`}>{user.representative.email}</a></p>
                        <SocialAccounts shape="circle" representative={user.representative} />

                    </section>
                </div>
                <div className="col-md-8">
                    {/*{showNewsLetterSignup &&*/}
                    {/*    (<div className="row mr-0 ml-0">*/}
                    {/*        <div className="col-md-8">*/}
                    {/*            <div className="float-right">*/}
                    {/*                <input type="checkbox" className="mr-2" checked={this.state.isChecked} onChange={this.subscribeToNewsletterHanlder} />*/}
                    {/*                <label>{t("Subscribe me to Newsletter")}</label>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>)}*/}
                    <div className="row mr-0 ml-0">
                        <div className="card mb-3 col-md-8">
                            <div className="card-body pl-0 pr-0">
                                <h4 className="card-title">{t("Welcome Message")}</h4>
                                <p className="card-text" dangerouslySetInnerHTML={{ __html: welcomeMessage }} />
                            </div>
                        </div>
                        <div className=" mb-3 col-md-4 pr-0">
                            {aboutMeButton1Url && <a className="btn btn-rounded enjo-background-color w-100 pl-2 btn-text-overflow" type="button" rel="noopener noreferrer"
                                                    title={aboutMeButton1Title} target={aboutMeButton1Target} href={aboutMeButton1Url}>{aboutMeButton1Title}</a>}
                            {aboutMeButton2Url && <a className="btn btn-rounded enjo-background-color w-100 pl-2 btn-text-overflow" type="button" rel="noopener noreferrer"
                                                    title={aboutMeButton2Title} target={aboutMeButton2Target} href={aboutMeButton2Url}>{aboutMeButton2Title}</a>}
                            {aboutMeButton3Url && <a className="btn btn-rounded enjo-background-color w-100 pl-2 btn-text-overflow" type="button" rel="noopener noreferrer"
                                                    title={aboutMeButton3Title} target={aboutMeButton3Target} href={aboutMeButton3Url}>{aboutMeButton3Title}</a>}
                            {aboutMeButton4Url && <a className="btn btn-rounded enjo-background-color w-100 pl-2 btn-text-overflow" type="button" rel="noopener noreferrer"
                                                    title={aboutMeButton4Title} target={aboutMeButton4Target} href={aboutMeButton4Url}>{aboutMeButton4Title}</a>}
                        </div>
                    </div>
                    {utils.isNullOrEmpty(aboutMeMessage) == false && <div className="card mb-3 about-me">
                        <div className="card-body">
                            <h4 className="card-title">{t("About Me Message")} </h4>
                            <p className="card-text" dangerouslySetInnerHTML={{ __html: aboutMeMessage }} />
                        </div>
                    </div>}
                    {utils.isNullOrEmpty(youtubeMessageUrl) == false && <div className="card mb-3 youtube">
                        <div className="card-body">
                            <ReactPlayer width="100%"
                                url={youtubeMessageUrl}
                            />
                        </div>
                    </div>}

                </div>
            </div>


        );
    }
}



function mapStateToProps({ user, settings, siteLinks, locale }, ownProps) {
    var newState = { user, settings, siteLinks, locale, ...ownProps };
    return newState;
}


AboutMe = connect(mapStateToProps, null /* { subscribeToNewsletter: subscribeToNewsletter }*/)(withRouter(AboutMe))

export default withTranslation()(AboutMe);




